import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import ChainedBackend from 'i18next-chained-backend';

const userLanguage = navigator.language;
const countryId = new URLSearchParams(window.location.search).get('countryId');

// Map specific countryId values to language codes. Extend as needed.
const countryLangMap = {
  '1': 'sv', // Sweden
  '9': 'en', // United Kingdom / English
};

const browserLang = (userLanguage || '').substring(0, 2).toLowerCase();
const supportedBrowserLang = ['sv', 'da', 'fi', 'no', 'de', 'en'].includes(browserLang)
  ? browserLang
  : 'en';

const activeLang = countryLangMap[countryId] || supportedBrowserLang;

const I18N_URL = process.env.REACT_APP_I18N_URL || '';

i18n
  .use(ChainedBackend)
  .use(initReactI18next)
  .init({
    backend: {
      backends: [HttpBackend, HttpBackend],
      backendOptions: [
        { loadPath: `${I18N_URL}?merged=true&languagecode=${activeLang}` },
        {
          loadPath: '/translations/{{lng}}.json',
          requestOptions: { mode: 'no-cors' },
        },
      ],
    },
    debug: false,
    lng: 'en',
    fallbackLng: 'en',
    defaultNS: 'translation',
    ns: ['translation'],
    interpolation: { escapeValue: false },
  });

export default i18n;